import * as React from "react";
import { Helmet } from "react-helmet-async";
import { useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import "./Hipaa.css";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

// @mui
import {
  Card,
  Stack,
  Button,
  Checkbox,
  Box,
  Radio,
  Container,
  FormGroup,
  Typography,
  Breadcrumbs,
  TextField,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import CustomSnackbar from "../../utils/CustomSnackbar";

import { useTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
// hooks
import useSettings from "../../hooks/useSettings";

// components
import Page from "../../components/Page";

// ----------------------------------------------------------------------

const Hipaa_Doctor = () => {
  const location = useLocation();
  const [openModel, setOpenModal] = useState(false);
  const [penColor, setPenColor] = useState("black");
  const colors = ["black", "green", "red"];
  const [imageURL, setImageURL] = useState(null);
  const create = () => {
    const URL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    setImageURL(URL);
    setOpenModal(false);
  };
  const sigCanvas = useRef();
  const [file, setFile] = useState();
  const handlePicChange = (e) => {
    //console.log(e.target.files);
    console.log("");
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  // const {id} = useParams()
  const [openSnack, setOpenSnack] = useState({
    open: false,
    severity: null,
    message: null,
  });
  const [data, setData] = useState([]);
  const [hipaa_digitally_sign, setHipaaDS] = useState("");
  const [hipaa_date, setHipaaDate] = useState(new Date());
  const [hipaa_print_name, setHipaaName] = useState("");
  const [hipaa_phone, setHipaaPhone] = useState("");
  const [hippa_patient_relationship, setHipaaRel] = useState("");
  const [hipaa_name_address, setHipaaAdrr] = useState("");
  // const [canvas, setCanvas] = useState(null);
  // const [canvasVisibility, setCanvasVisibility] = useState(false);

  // const clearSignatureCanvas = useCallback(() => {
  //   signRef.current.clear();
  //   setCanvas(undefined);
  //   setCanvasVisibility(false);
  // }, []);

  // const handleGetCanvas = useCallback(() => {
  //   const canvas = signRef.current.toDataURL();

  //   setCanvas(canvas);
  //   setCanvasVisibility(true);
  // }, []);

  const [value, setValue] = React.useState(null);

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const handleFormSubmit = (values) => {
    //console.log(values);
    console.log("");
  };

  useEffect(() => {
    axios
      .post(
        "https://ehr.kaizendigital.ai/api/dev1/2222/fetchspatient",
        JSON.stringify({ patient_id: location.state.id })
      )
      .then((response) => {
        // console.log(id)
        //console.log(response)
        console.log("");
        setData(response.data);
        setHipaaDS(response.data[0].hipaa_digitally_sign);
        setHipaaDate(response.data[0].hipaa_date);
        setHipaaName(response.data[0].hipaa_print_name);
        setHipaaPhone(response.data[0].hipaa_phone);
        setHipaaRel(response.data[0].hippa_patient_relationship);
        setHipaaAdrr(response.data[0].hipaa_name_address);
      })
      .catch((err) => {
        //console.log(err);
        console.log("");
      });
  }, []);

  function handleSave(event, patient_id) {
    event.preventDefault();
    axios
      .put("https://ehr.kaizendigital.ai/api/dev1/2222/hipaa-s8", {
        patient_id: location.state.id,
        hipaa_digitally_sign: hipaa_digitally_sign,
        hipaa_date: hipaa_date,
        hipaa_print_name: hipaa_print_name,
        hipaa_phone: hipaa_phone,
        hippa_patient_relationship: hippa_patient_relationship,
        hipaa_name_address: hipaa_name_address,
      })
      .then((res) => {
        //console.log(res)
        console.log("");
        {
          setOpenSnack({
            open: true,
            severity: "success",
            message: "Details Saved Successfully",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            //   navigate("../");
            setOpenSnack({ open: false });
          }, 3000);
        }
      })
      .catch((err) => {
        //console.log(err)
        console.log("");
        {
          setOpenSnack({
            open: true,
            severity: "error",
            message: "Something went Wrong",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            // navigate("../");
            setOpenSnack({ open: false });
          }, 3000);
        }
      });
  }
  const { themeStretch } = useSettings();
  const { open, severity, message, position } = openSnack;

  return (
    <>
      {CustomSnackbar(open, severity, message, position)}

      <Helmet>
        <title> Patients| Kaizen Digital </title>
      </Helmet>
      <Page title="Page Two">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <Stack direction="column" spacing={0}>
            <Stack direction="column" spacing={0}>
              {/* <Typography variant="h4" gutterBottom color="primary">
            Add Patient       
          </Typography> */}
              <div role="presentation">
                {/* <Breadcrumbs aria-label="breadcrumb">
        <Typography 
        sx={{ display: 'flex', alignItems: 'center' }}
        color="text.primary">
          Dashboard
        </Typography>
        
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
Patients        </Typography>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
         Add Patient
        </Typography>
      </Breadcrumbs> */}
              </div>
              <Box m="20px">
                <Card>
                  <Box m="20px">
                    <Helmet>
                      <title> Add Patient_1 | Kaizen Digital </title>
                    </Helmet>

                    <br />
                    <Stack direction="column" spacing={0}>
                      <Typography color="primary" variant="h4" gutterBottom>
                        HIPAA Notice of Privacy Practices
                      </Typography>
                    </Stack>
                  </Box>
                  <Box m="20px">
                    <p>Effective Date:03/01/2017</p>
                    <p>
                      THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU
                      MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO
                      THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.
                    </p>{" "}
                    <br />
                    <p>
                      We understand the importance of privacy and are committed
                      to maintaining the confidentiality of your medical
                      information. We make a record of the medical care we
                      provide and may receive such records from others. We use
                      these records to provide or enable other health care
                      providers to provide quality medical care, to obtain
                      payment for services provided to you as allowed by your
                      health plan and to enable us to meet our professional and
                      legal obligations to operate this medical practice
                      properly. We are required by law to maintain the privacy
                      of protected health information and to provide individuals
                      with notice of our legal duties and privacy practices with
                      respect to protected health information. This notice
                      describes how we may use and disclose your medical
                      information. It also describes your rights and our legal
                      obligations with respect to your medical information. If
                      you have any questions about this Notice, please contact
                      our office's Privacy Officer
                    </p>
                    <br />
                    <p>
                      A. How This Medical Practice May Use or Disclose Your
                      Health Information
                    </p>
                    <br />
                    <p>
                      This medical practice collects health information about
                      you and stores it in a chart and on a computer. This is
                      your medical record. The medical record is the property of
                      this medical practice, but the information in the medical
                      record belongs to you. The law permits us to use or
                      disclose your health information for the following
                      purposes:
                    </p>
                    <br />
                    <p>
                      1. <b>Treatment.</b>We use medical information about you
                      to provide your medical care. We disclose medical
                      information to our employees and others who are involved
                      in providing the care you need. For example, we may share
                      your medical information with other physicians or other
                      health care providers who will provide services which we
                      do not provide. Or we may share this information with a
                      pharmacist who needs it to dispense a prescription to you,
                      a home health agency, or a laboratory that performs a test
                      and so forth. We may also disclose medical information to
                      members of your family or others who can help you when you
                      are sick or injured.{" "}
                    </p>
                    <br />
                    <p>
                      2. <b>Payment.</b> We use and disclose medical information
                      about you to obtain payment for the services we provide.
                      For example, we give your health plan the information it
                      requires before it will pay us. We may also disclose
                      information to other health care providers to assist them
                      in obtaining payment for services they have provided to
                      you. From time to time we may relay information to a
                      collection agency if any balance is left outstanding.
                    </p>
                    <br />
                    <p>
                      3. <b>Health Care Operations</b> We may use and disclose
                      medical information about you to operate this medical
                      practice, or to train medical residents and healthcare
                      students. For example, we may use and disclose this
                      information to review and improve the quality of care we
                      provide, or the competence and qualifications of our
                      professional staff. Or we may use and disclose this
                      information to get your health plan to authorize services
                      or referrals. We may also use and disclose this
                      information as necessary for medical reviews, legal
                      services and audits, including fraud and abuse detection
                      and compliance programs and business planning and
                      management. We may also share your medical information
                      with our "business associates," such as our billing
                      service, that perform administrative services for us. We
                      have a written contract with each of these business
                      associates that contains terms requiring them to protect
                      the confidentiality and security of your medical
                      information. Although federal law does not protect health
                      information which is disclosed to someone other than
                      another healthcare provider, health plan or healthcare
                      clearinghouse, under California law all recipients of
                      health care information are prohibited from re-disclosing
                      it except as specifically required or permitted by law. We
                      may also share your information with other health care
                      providers, health care clearinghouses or health plans that
                      have a relationship with you, when they request this
                      information to help them with their quality assessment and
                      improvement activities, their efforts to improve health or
                      reduce health care costs, their review of competence,
                      qualifications and performance of health care
                      professionals, their training programs, their
                      accreditation, certification or licensing activities, or
                      their health care fraud and abuse detection and compliance
                      efforts. We may also share medical information about you
                      with the other health care providers, health care
                      clearinghouses and health plans that participate with us
                      in "organized health care arrangements" (OHCAs) for any of
                      the OHCAs' health care operations. OHCAs include
                      hospitals, physician organizations, health plans, and
                      other entities which collectively provide health care
                      services. A listing of the OHCAs we participate in is
                      available from the Privacy Official.{" "}
                    </p>
                    <br />
                    <p>
                      4. <b>Appointment Reminders.</b> We may use and disclose
                      medical information to contact and remind you about
                      appointments. If you are not home, we may leave this
                      information on your answering machine or in a message left
                      with the person answering the phone{" "}
                    </p>
                    <br />
                    <p>
                      5. <b>Sign In Sheet.</b> We may use and disclose medical
                      information about you by having you sign in when you
                      arrive at our office. We may also call out your name when
                      we are ready to see you.{" "}
                    </p>
                    <br />
                    <p>
                      6. <b>Notification and Communication With Family.</b> We
                      may disclose your health information to notify or assist
                      in notifying a family member, your personal representative
                      or another person responsible for your care about your
                      location, your general condition or in the event of your
                      death. In the event of a disaster, we may disclose
                      information to a relief organization so that they may
                      coordinate these notification efforts. We may also
                      disclose information to someone who is involved with your
                      care or helps pay for your care. We may also disclose
                      health information to your family and friends if we can
                      infer from circumstances, based on our professional
                      judgment, that you would not object. For example, we may
                      assume you agree to our disclosure of your personal health
                      information to your spouse when you bring your spouse with
                      you into an exam room during treatment or while treatment
                      is discussed. If you are able and available to agree or
                      object, we will give you the opportunity to object prior
                      to making these disclosures, although we may disclose this
                      information in a disaster even over your objection if we
                      believe it is necessary to respond to the emergency
                      circumstances. If you are unable or unavailable to agree
                      or object, our health professionals will use their best
                      judgment in communication with your family and others. In
                      that situation, we will disclose only health information
                      relevant to the persons involvement in your care. For
                      example, we may inform the person who accompanied you to
                      the emergency room that you suffered a heart attack and
                      provide updates on your progress and prognosis.{" "}
                    </p>
                    <br />
                    <p>
                      7. <b> Marketing </b>. We may contact you to give you
                      information about products or services related to your
                      treatment, case management or care coordination, or to
                      direct or recommend other treatments or health-related
                      benefits and services that may be of interest to you, or
                      to provide you with small gifts. We may also encourage you
                      to purchase a product or service when we see you. If you
                      are currently an enrollee of a health plan, we may receive
                      payment for communications to you in conjunction with our
                      provision, coordination, or management of your health care
                      and related services, including our coordination or
                      management of your health care with a third party, our
                      consultation with other health care providers relating to
                      your care, or if we refer you for health care, but only to
                      the extent these communications describe: 1) a provider's
                      participation in the health plan's network, 2) the extent
                      of your covered benefits, or 3) concerning the
                      availability of more cost-effective pharmaceuticals. We
                      will not accept any payment for other marketing
                      communications without your prior written authorization
                      unless you have a chronic and seriously debilitating or
                      life-threatening condition and we are making the
                      communication in conjunction with our provision,
                      coordination, or management of your health care and
                      related services, including our coordination or management
                      of your health care with a third party, our consultation
                      with other health care providers relating to your care, or
                      if we refer you for health care. If we make these types of
                      communications to you while you have a chronic and
                      seriously debilitating or life-threatening condition, we
                      will tell you who is paying us, and we will also tell you
                      how to stop these communications if you prefer not to
                      receive them. We will not otherwise use or disclose your
                      medical information for marketing purposes without your
                      written authorization, and we will disclose whether we
                      receive any payments for any marketing activity you
                      authorize.{" "}
                    </p>
                    <br />
                    <p>
                      8. <b>Required by Law</b>. As required by law, we will use
                      and disclose your health information, but we will limit
                      our use or disclosure to the relevant requirements of the
                      law. When the law requires us to report abuse, neglect or
                      domestic violence, or respond to judicial or
                      administrative proceedings, or to law enforcement
                      officials, we will further comply with the requirement set
                      forth below concerning those activities.{" "}
                    </p>
                    <br />
                    <p>
                      9. <b> Public Health </b>. We may, and are sometimes
                      required by law to disclose your health information to
                      public health authorities for purposes related to:
                      preventing or controlling disease (for example to alert a
                      person who may have been exposed to a communicable disease
                      or may otherwise be at risk of contracting or spreading a
                      disease), injury or disability; reporting child, elder or
                      dependent adult abuse or neglect; reporting domestic
                      violence (if we reasonably believe that you are a victim
                      of abuse, neglect or domestic violence, we may disclose
                      your health information as required by law to a social
                      services or other governmental agency authorized by law to
                      receive such reports); reporting to the Food and Drug
                      Administration problems with products and reactions to
                      medications; and reporting disease or infection exposure.
                      When we report suspected elder or dependent adult abuse or
                      domestic violence, we will inform you or your personal
                      representative promptly unless in our best professional
                      judgment, we believe the notification would place you at
                      risk of serious harm or would require informing a personal
                      representative we believe is responsible for the abuse or
                      harm.{" "}
                    </p>
                    <br />
                    <p>
                      10. <b>Health Oversight Activities</b>. We may, and are
                      sometimes required by law to disclose your health
                      information to health oversight agencies during the course
                      of audits, investigations, inspections, licensure and
                      other proceedings, subject to the limitations imposed by
                      federal and California law.{" "}
                    </p>
                    <br />
                    <p>
                      11. <b> Judicial and Administrative Proceedings</b>. We
                      may, and are sometimes required by law, to disclose your
                      health information in the course of any administrative or
                      judicial proceeding to the extent expressly authorized by
                      a court or administrative order. We may also disclose
                      information about you in response to a subpoena, discovery
                      request or other lawful process if reasonable efforts have
                      been made to notify you of the request and you have not
                      objected, or if your objections have been resolved by a
                      court or administrative order.{" "}
                    </p>
                    <br />
                    <p>
                      12. <b> Law Enforcement </b>. We may, and are sometimes
                      required by law, to disclose your health information to a
                      law enforcement official for purposes such as identifying
                      of locating a suspect, fugitive, material witness or
                      missing person, complying with a court order, warrant,
                      grand jury subpoena and other law enforcement purposes.{" "}
                    </p>
                    <br />
                    <p>
                      13.{" "}
                      <b> Coroners, Medical Examiners and Funeral Directors.</b>{" "}
                      We may, and are often required by law, to disclose your
                      health information to coroners, Medical Examiners and
                      Funeral Directors in connection with their investigations
                      of deaths.{" "}
                    </p>
                    <br />
                    <p>
                      14. <b> Organ or Tissue Donation.</b> We may disclose your
                      health information to organizations involved in procuring,
                      banking or transplanting organs and tissues.{" "}
                    </p>
                    <br />
                    <p>
                      15. <b> Public Safety. </b> We may, and are sometimes
                      required by law, to disclose your health information to
                      appropriate persons in order to prevent or lessen a
                      serious and imminent threat to the health or safety of a
                      particular person or the general public.{" "}
                    </p>
                    <br />
                    <p>
                      16. <b> Specialized Government Functions.</b> We may
                      disclose your health information for military or national
                      security purposes or to correctional institutions or law
                      enforcement officers that have you in their lawful
                      custody. If you are or were a member of the armed forces,
                      or part of the national security or intelligence
                      communities, we may be required by military command or
                      other governmental authorities to release health
                      information about you. We may also release information
                      about foreign military personnel to the appropriate
                      foreign military authority.{" "}
                    </p>
                    <br />
                    <p>
                      17. <b> Worker's Compensation.</b> We may disclose your
                      health information as necessary to comply with worker's
                      compensation laws. For example, to the extent your care is
                      covered by workers' compensation, we will make periodic
                      reports to your employer about your condition. We are also
                      required by law to report cases of occupational injury or
                      occupational illness to the employer or workers'
                      compensation insurer.{" "}
                    </p>
                    <br />
                    <p>
                      18. <b> Change of Ownership. </b> In the event that this
                      medical practice is sold or merged with another
                      organization, your health information/record will become
                      the property of the new owner, although you will maintain
                      the right to request that copies of your health
                      information be transferred to another physician or medical
                      group.{" "}
                    </p>
                    <br />
                    <p>
                      19. <b> Breach Notification.</b> In the case of a breach
                      of unsecured protected health information, we will notify
                      you as required by law. If you have provided us with a
                      current email address, we may use email to communicate
                      information related to the breach. In some circumstances
                      our business associate may provide the notification. We
                      may also provide notification by other methods as
                      appropriate.{" "}
                    </p>
                    <br />
                    <p>
                      B. When This Medical Practice May Not Use or Disclose Your
                      Health Information
                    </p>
                    <br />
                    <p>
                      Except as described in this Notice of Privacy Practices,
                      this medical practice will not use or disclose health
                      information which identifies you without your written
                      authorization. If you do authorize this medical practice
                      to use or disclose your health information for another
                      purpose, you may revoke your authorization in writing at
                      any time.
                    </p>
                    <br />
                    <p>C. Your Health Information Rights</p>
                    <br />
                    <p>
                      1. <b> Right to Request Special Privacy Protections.</b>{" "}
                      You have the right to request restrictions on certain uses
                      and disclosures of your health information by a written
                      request specifying what information you want to limit, and
                      what limitations on our use or disclosure of that
                      information you wish to have imposed. If you tell us not
                      to disclose information to your commercial health plan
                      concerning health care items or services for which you
                      paid for in full out-of-pocket, we will abide by your
                      request, unless we must disclose the information for
                      treatment or legal reasons. We reserve the right to accept
                      or reject any other request, and will notify you of our
                      decision.{" "}
                    </p>
                    <br />
                    <p>
                      2. <b> Right to Request Confidential Communications.</b>{" "}
                      You have the right to request that you receive your health
                      information in a specific way or at a specific location.
                      For example, you may ask that we send information to a
                      particular e-mail account or to your work address. We will
                      comply with all reasonable requests submitted in writing
                      which specify how or where you wish to receive these
                      communications.{" "}
                    </p>
                    <br />
                    <p>
                      3. <b> Right to Inspect and Copy. </b> You have the right
                      to inspect and copy your health information, with limited
                      exceptions. To access your medical information, you must
                      submit a written request detailing what information you
                      want access to and whether you want to inspect it or get a
                      copy of it. We will charge a reasonable fee, as allowed by
                      California and federal law. We may deny your request under
                      limited circumstances. If we deny your request to access
                      your child's records or the records of an incapacitated
                      adult you are representing because we believe allowing
                      access would be reasonably likely to cause substantial
                      harm to the patient, you will have a right to appeal our
                      decision. If we deny your request to access your
                      psychotherapy notes, you will have the right to have them
                      transferred to another mental health professional. If your
                      written request clearly, conspicuously and specifically
                      asks us to send you or some other person or entity an
                      electronic copy of your medical record, and we do not deny
                      the request as discussed above, we will send a copy of the
                      electronic health record as you requested, and will charge
                      you no more than what it cost us to respond to your
                      request.
                    </p>
                    <br />
                    <p>
                      4. <b> Right to Amend or Supplement.</b> You have a right
                      to request that we amend your health information that you
                      believe is incorrect or incomplete. You must make a
                      request to amend in writing, and include the reasons you
                      believe the information is inaccurate or incomplete. We
                      are not required to change your health information, and
                      will provide you with information about this medical
                      practice's denial and how you can disagree with the
                      denial. We may deny your request if we do not have the
                      information, if we did not create the information (unless
                      the person or entity that created the information is no
                      longer available to make the amendment), if you would not
                      be permitted to inspect or copy the information at issue,
                      or if the information is accurate and complete as is. You
                      also have the right to request that we add to your record
                      a statement of up to 250 words concerning any statement or
                      item you believe to be incomplete or incorrect.{" "}
                    </p>
                    <br />
                    <p>
                      5. <b> Right to an Accounting of Disclosures. </b> You
                      have a right to receive an accounting of disclosures of
                      your health information made by this medical practice,
                      except that this medical practice does not have to account
                      for the disclosures provided to you or pursuant to your
                      written authorization, or as described in paragraphs 1
                      (treatment), 2 (payment), 3 (health care operations), 6
                      (notification and communication with family) and 16
                      (specialized government functions) of Section A of this
                      Notice of Privacy Practices or disclosures for purposes of
                      research or public health which exclude direct patient
                      identifiers, or which are incident to a use or disclosure
                      otherwise permitted or authorized by law, or the
                      disclosures to a health oversight agency or law
                      enforcement official to the extent this medical practice
                      has received notice from that agency or official that
                      providing this accounting would be reasonably likely to
                      impede their activities.{" "}
                    </p>
                    <br />
                    <p>
                      6.{" "}
                      <b>
                        {" "}
                        You have a right to a paper copy of this Notice of
                        Privacy Practices.
                      </b>{" "}
                      We do not use e-mail to distribute the Notice of Privacy
                      Practices.{" "}
                    </p>
                    <br />
                    <p>
                      If you would like to have a more detailed explanation of
                      these rights or if you would like to exercise one or more
                      of these rights, contact our Privacy Officer listed at the
                      top of this Notice of Privacy Practices.
                    </p>
                    <br />
                    <p>D. Changes to this Notice of Privacy Practices</p>
                    <br />
                    <p>
                      We reserve the right to amend this Notice of Privacy
                      Practices at any time in the future. Until such amendment
                      is made, we are required by law to comply with this
                      Notice. After an amendment is made, the revised Notice of
                      Privacy Protections will apply to all protected health
                      information that we maintain, regardless of when it was
                      created or received. We will keep a copy of the current
                      notice posted in our reception area, and a copy will be
                      available at each appointment. We will also post the
                      current notice on our website.
                    </p>
                    <br />
                    <p>E. Complaints</p>
                    <br />
                    <p>
                      Complaints about this Notice of Privacy Practices or how
                      this medical practice handles your health information
                      should be directed to our Privacy Officer listed at the
                      top of this Notice of Privacy Practices.
                    </p>
                    <br />
                    <p>
                      If you are not satisfied with the manner in which this
                      office handles a complaint, you may submit a formal
                      complaint to:
                    </p>
                    <br />
                    <p>
                      Region IX Office for Civil Rights
                      <br />
                      U.S. Department of Health &amp; Human Services
                      <br />
                      90 7th Street, Suite 4- 100 San Francisco, CA 94103
                      <br />
                      (415) 437-831 O; (415) 437-8311 (TDD)
                      <br />
                      (415) 437-8329 FAX
                      <br />
                      <a href="mailto:OCRMail@hhs.gov">
                        OCRMail@hhs.gov
                        <br />
                      </a>
                      The complaint form may be found atwww.hhs.gov/ocr/privacy
                      /hipaa/complaints/hipcomplaint.pdf. You will not be
                      penalized for filing a complaint.
                    </p>
                    <h4>HIPAA NOTICE OF PRIVACY PRACTICES</h4>
                    <h5>Acknowledgement of Receipt</h5>
                    <p>
                      Kaizen Brain Center
                      <br />
                      41 80 La Jolla Village Drive, Suite 240 <br />
                      La Jolla, CA 92037
                      <br />
                      (866) 277-2659
                    </p>
                    <br />
                    <p>
                      I hereby acknowledge that I received a copy of this
                      medical practice's Notice of Privacy Practices. I further
                      acknowledge that a copy of the current notice will be
                      posted in the reception area, and that a copy of any
                      amended Notice of Privacy Practices will be available at
                      each appointment.
                    </p>
                    <br />
                  </Box>
                  {/* <Box m="20px">
    <h4>Signature</h4>
    <div className="sign" style={{width:"500px",height:"200px",border:"2px solid black"}} >
    <SignatureCanvas
        ref={signRef}
        canvasProps={{
          width: 500,
          height: 200
        }}
      />
    </div>
    <div>
    <Button type="submit" onClick={clearSignatureCanvas}  variant="contained"style={{margin:"3vh"}} >
                Clear Signature
              </Button>
    <Button type="submit" onClick={handleGetCanvas}  variant="contained" >
                Submit Signature
              </Button>          
  </div>
  {canvasVisibility && 
  <div style={{display:"flex",width:"600px",height:"300px"}}>
  <img src={canvas} alt="signature" />
  </div>
  } 
</Box> */}

                  {/* ASIFs SIGNATURE RELATED WORK - 3 options */}
                  {/* <Box m="20px">
  <Typography><strong>Signature</strong></Typography>
  
  <Button onClick={ () => setOpenModal(true)}>Digitally Sign the signature</Button>
  <Button component="label">
        Upload Signature Picture
        <input hidden onChange={handlePicChange} multiple type="file" />
  </Button>
  <br />
  <img src={file} />
  {
  imageURL && (
    <>
      <img src={imageURL} alt="signature" className="signature" />
    </>
  )
}
  {openModel && (
    <div className="modalContainer">
      <div className="modal">
      
      <div className="sigPadContainer">
  <SignatureCanvas penColor="black"
  canvasProps={{ className: "sigCanvas" }}
  ref={sigCanvas}/>
  <Button onClick={() => sigCanvas.current.clear()}>Clear</Button>
</div>
        <div className="modal__bottom">
    <Button onClick={ () => setOpenModal(false)}>Cancel</Button>
    <Button onClick={create}>
  Submit
</Button>
    </div>
    </div>
    </div>
  )}
  
</Box> */}

                  <Box m="20px">
                    <Formik onSubmit={handleFormSubmit}>
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <Box>
                            <Box
                              display="grid"
                              gap="30px"
                              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                              sx={{
                                "& > div": {
                                  gridColumn: isNonMobile
                                    ? undefined
                                    : "span 4",
                                },
                              }}
                            >
                              <TextField
                                label="Signature"
                                value={hipaa_digitally_sign}
                                onChange={(e) => setHipaaDS(e.target.value)}
                                sx={{ gridColumn: "span 1" }}
                              />

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Enter Date"
                                  format="MM-DD-YYYY"
                                  value={dayjs(hipaa_date)}
                                  name="hipaa_date"
                                  // onChange={(date) =>{setFieldValue("hipaa_date", date)} }
                                  onChange={(e) => setHipaaDate(e)}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                  // error={!!touched.hipaa_date && !!errors.hipaa_date}
                                  // helperText={touched.hipaa_date && errors.hipaa_date}
                                />
                              </LocalizationProvider>

                              <TextField
                                fullWidth
                                id="sub"
                                type="text"
                                label="Print name"
                                name="lastName"
                                value={hipaa_print_name}
                                onChange={(e) => setHipaaName(e.target.value)}
                                // error={!!touched.lastName && !!errors.lastName}
                                sx={{ gridColumn: "span 1" }}
                              />
                              <TextField
                                fullWidth
                                id="sub"
                                type="number"
                                label="Phone"
                                value={hipaa_phone}
                                onChange={(e) => setHipaaPhone(e.target.value)}
                                // error={!!touched.lastName && !!errors.lastName}
                                sx={{ gridColumn: "span 1" }}
                              />
                            </Box>{" "}
                            <br />
                            <p>
                              If not signed by the patient, please indicate
                              relationship:
                            </p>
                            <br />
                            <FormGroup column>
                              <Stack direction="row">
                                <FormControlLabel
                                  value="m"
                                  // checked
                                  control={
                                    <Radio
                                      value="minor"
                                      onClick={(e) => {
                                        setHipaaRel("minor");
                                      }}
                                      checked={
                                        hippa_patient_relationship === "minor"
                                      }
                                    />
                                  }
                                  label="Parent or guardian of minor patient"
                                  labelPlacement="end"
                                />
                              </Stack>
                              <Stack direction="row">
                                <FormControlLabel
                                  value="incompetent"
                                  // checked
                                  control={
                                    <Radio
                                      value="incompetent"
                                      onClick={(e) => {
                                        setHipaaRel("incompetent");
                                      }}
                                      checked={
                                        hippa_patient_relationship ===
                                        "incompetent"
                                      }
                                    />
                                  }
                                  label="Guardian or conservator of an incompetent patient"
                                  labelPlacement="end"
                                />
                              </Stack>
                            </FormGroup>
                            <br />
                            <TextField
                              fullWidth
                              id="sub"
                              type="text"
                              label="Name and Address of a Patient"
                              name="lastName"
                              value={hipaa_name_address}
                              onChange={(e) => setHipaaAdrr(e.target.value)}
                              // error={!!touched.lastName && !!errors.lastName}
                              sx={{ gridColumn: "span 1" }}
                            />
                            <br />
                            <br />
                            <br />
                            <Stack sx={{ gridColumn: "span 3" }}></Stack>
                            <Stack sx={{ gridColumn: "span 1" }}>
                              <Button
                                onClick={handleSave}
                                variant="contained"
                                sx={{ width: "220px", color: "white" }}
                              >
                                {" "}
                                SAVE PATIENT DETAILS
                              </Button>
                            </Stack>
                          </Box>
                        </form>
                      )}
                    </Formik>
                  </Box>
                </Card>
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Page>
    </>
  );
};

export default Hipaa_Doctor;
